import { render, staticRenderFns } from "./ZYDetail.vue?vue&type=template&id=e9506fa6&scoped=true&"
import script from "./ZYDetail.vue?vue&type=script&lang=js&"
export * from "./ZYDetail.vue?vue&type=script&lang=js&"
import style0 from "./ZYDetail.vue?vue&type=style&index=0&id=e9506fa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9506fa6",
  null
  
)

export default component.exports